<div class="no-instance-container">
    <div class="no-instance-card">
        <h1 class="title">No AskSkip Instance Assigned</h1>
        <p class="message">
            Your organization has not yet added you to an AskSkip instance.
            Please contact your administrator for access.
        </p>
    </div>
</div>